import {addCustomCSS} from "@ui5/webcomponents-base/dist/Theming";

addCustomCSS("ui5-select", `
	.ui5-select-root ui5-li:first-child {
		display: none;
	}
`);

// We need to know when UI5 classic has loaded CSS Variables fo the WebComponents.
// Currently, there are couple ways for UI5 Classic to achieve this- via xx-cssVariables (Core feature, experimental)
// or by providing explicit CSS Vars for the WebComponents in the AdaptiveCards (integration library).
// As checking on URL/config is fine, we cannot detect whether a custom library for which there's CSS Vars support
// in cards has been created. We need to find a reliable way to detect if CSS Vars are present.
// We know that removing LESS param/CSS VAriable is considered a backwards incompatibility. So, getting one of the
// core Params/Vars and checking its value should be enough to detect if CSS Vars are loaded or not.
//
// Important: There's a certainty that UI5 Classic has been loaded prior WebComponents. WebComponents' library gets loaded
// within UI5 Classic control
// const computedStyles = getComputedStyle(document.documentElement),
// 	isExternalThemePresent = sap && sap.ui && sap.ui.getCore &&
// 		(!!computedStyles.getPropertyValue('--sapFontFamily') ||
// !!computedStyles.getPropertyValue('--sapBrandColor') ||
//!!computedStyles.getPropertyValue('--sapBaseColor'));

// setExternalThemePresent(isExternalThemePresent);
